import { isEqual } from 'lodash/fp';

import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import { ReportRun } from 'dashboard/models/report-run';
import { ReportRunsActions, ReportRunsActionType } from 'dashboard/redux/actions/report-runs';
import { ReportRunsFilterParams } from 'dashboard/redux/thunk-actions/report-runs';

export interface ReportRunsState extends TableState<ReportRunsFilterParams> {
  reportRuns: Record<string, ReportRun[]>;
}

const initialReportRunsState: ReportRunsState = {
  reportRuns: {},
  filters: {
    reportTemplateVersionIds: [],
  },
  paginationParams: undefined,
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
  sortParams: {
    sort: 'result',
    shouldSortDescending: false,
  },
};

export default (state: ReportRunsState = initialReportRunsState, action: ReportRunsActions) => {
  switch (action.type) {
    case ReportRunsActionType.SetReportRuns: {
      return {
        ...state,
        reportRuns: {
          ...state.reportRuns,
          [action.payload.environment.id]: action.payload.reportRuns,
        },
        paginationParams: action.payload.paginationParams,
      };
    }
    case ReportRunsActionType.SetReportRun: {
      return {
        ...state,
        reportRuns: {
          ...state.reportRuns,
          [action.payload.environment.id]: state.reportRuns[action.payload.environment.id]?.map(
            (run) => (run.id === action.payload.reportRun.id ? action.payload.reportRun : run),
          ),
        },
      };
    }
    case ReportRunsActionType.ClearReportRuns: {
      return {
        ...state,
        reportRuns: {
          ...state.reportRuns,
          [action.payload.environment.id]: [],
        },
      };
    }
    case ReportRunsActionType.SetCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }
    case ReportRunsActionType.SetPageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }
    case ReportRunsActionType.SetFilters: {
      const newFilters = {
        ...state.filters,
        ...action.payload.filters,
      };

      if (isEqual(newFilters, state.filters)) {
        return state;
      } else {
        return {
          ...state,
          filters: newFilters,
        };
      }
    }
    case ReportRunsActionType.SetSortParams: {
      return {
        ...state,
        sortParams: {
          ...action.payload.sortParams,
        },
      };
    }
    default:
      return state;
  }
};
